import { useEffect, useState } from 'react';
import { DateTime } from 'luxon';
import { useDispatch, useSelector } from 'react-redux';

import { usePatchProjectMutation } from '@greenkub-fronts/data-access';
import {
  AppDispatch,
  FixMe,
  Project,
  RootState,
} from '@greenkub-fronts/shared/interface';
import {
  addErrorMessage,
  addPositiveMessage,
} from '@greenkub-fronts/domain/snackbar';
import {
  getCurrentProject,
  openModalSignature,
} from '@greenkub-fronts/domain/signature';

import DechargeTravauxSansDeclaration from '../../../ui/web/template/decharge-travaux-sans-declaration/decharge-travaux-sans-declaration';
import { useDebounce } from 'react-use';

export interface DechargeTravauxSansDeclarationFeatureProps {
  sign1Ref: FixMe;
}

const DechargeTravauxSansDeclarationFeature = (
  props: DechargeTravauxSansDeclarationFeatureProps
) => {
  const { sign1Ref } = props;

  const [patchProject] = usePatchProjectMutation();

  const { isSignature, signature, signatures } = useSelector(
    (state: RootState) => state.signature
  );

  const project = useSelector((state: RootState) => getCurrentProject(state));

  const dispatch = useDispatch<AppDispatch>();

  const [body, setBody] = useState<string>();
  const [body2, setBody2] = useState<string>();
  const [lastName, setLastName] = useState<string>();
  const [firstName, setFirstName] = useState<string>();
  const [date] = useState(DateTime.local());

  /**
   * INIT
   */
  useEffect(() => {
    if (!body)
      setBody(
        project?.dechargeTravauxSansDeclaration?.body
          ? project.dechargeTravauxSansDeclaration.body
          : "Atteste sur l'honneur ma volonté de faire installer par la société GREENKUB une construction bois qui n'a pas été déclarée en mairie"
      );
    if (!body2)
      setBody2(
        project?.dechargeTravauxSansDeclaration?.body2
          ? project.dechargeTravauxSansDeclaration.body2
          : "J'accepte d'assumer l'entière responsabilité de cette décision et décharge donc la société GREENKUB de toutes responsabilités"
      );
    if (!lastName)
      setLastName(
        project?.dechargeTravauxSansDeclaration?.lastName
          ? project.dechargeTravauxSansDeclaration.lastName
          : project?.customer.lastName
      );
    if (!firstName)
      setFirstName(
        project?.dechargeTravauxSansDeclaration?.firstName
          ? project.dechargeTravauxSansDeclaration.firstName
          : project?.customer.firstName
      );
  }, []);

  /**
   * EDITION
   */
  const updateData = () => {
    if (isSignature) return;
    const dechargeTravauxSansDeclaration = {
      body,
      body2,
      lastName,
      firstName,
    };
    patchProject({
      projectId: project?.id,
      project: { dechargeTravauxSansDeclaration },
    }).then((resp: any) => {
      if (resp.error) {
        dispatch(addErrorMessage(resp.error));
      } else {
        dispatch(addPositiveMessage(resp.data));
      }
    });
  };

  useDebounce(
    async () => {
      if (isSignature) return;
      updateData();
    },
    2000,
    [body, body2, lastName, firstName, date]
  );

  return (
    <DechargeTravauxSansDeclaration
      project={project as Project}
      isSignature={isSignature}
      signature={signature}
      signatures={signatures}
      handleOpenModalSignHandler={(index: number) =>
        dispatch(openModalSignature({ currentIndexSignature: index }))
      }
      sign1Ref={sign1Ref}
      body={body || ''}
      body2={body2 || ''}
      setBody={setBody}
      setBody2={setBody2}
      firstName={firstName || ''}
      setFirstName={setFirstName}
      lastName={lastName || ''}
      setLastName={setLastName}
      date={date}
    />
  );
};

export default DechargeTravauxSansDeclarationFeature;
